import { Autocomplete, Button, FormControl, Grid, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import * as React from 'react';
import Common from '../utilities/common';
import { TipoVia } from '../TiposVia/TipoVia';
import $ from "jquery";
import { Municipio } from '../Municipios/Municipio';
import { Provincia } from '../Provincias/Provincia';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export class SearchModel {
    field: string | undefined = '';
    value: string | undefined = '';
    operator: string | undefined = '';
    concatenator: string | undefined = '';
}

export interface IDataSearchFormProps {
    onSearchEnd?: any;
    onSearchModelChange?: any;
    multiFields?: boolean;
    extracciones?: boolean;
    clientId?: number;
}

export interface IDataSearchFormState {
    data: any[];
    searchModel: SearchModel[];
    tiposVia: TipoVia[];
    municipios: Municipio[];
    provincias: Provincia[];
}

export default class DataSearchForm extends React.Component<IDataSearchFormProps, IDataSearchFormState> {
    public constructor(props: IDataSearchFormProps) {
        super(props);

        this.state = {
            data: [],
            searchModel: [
                {
                    field: '',
                    value: '',
                    operator: '',
                    concatenator: ''
                }
            ],
            tiposVia: [],
            municipios: [],
            provincias: []
        }
    }

    componentDidMount(): void {
        this.GetTiposVia();
        this.GetMunicipios();
        this.GetProvincias();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.state.searchModel.map((searchModel: SearchModel, index: number) => {
                        return (
                            <Grid container spacing={3} style={{marginBottom: '20px'}}>
                                <Grid item xs={4}>
                                    <FormControl fullWidth>
                                        <InputLabel id="fieldLabel">Campo</InputLabel>
                                        <Select
                                            labelId="fieldLabel"
                                            id="fieldSelect"
                                            value={searchModel.field}
                                            label="Campo"
                                            onChange={(event: SelectChangeEvent) => {
                                                const searchModel: SearchModel[] = this.state.searchModel;

                                                searchModel[index].field = event.target.value as string;

                                                this.setState(
                                                    {
                                                        searchModel: searchModel
                                                    }
                                                );
                                            }}
                                        >
                                            <MenuItem value={'Nombre'}>Nombre</MenuItem>
                                            <MenuItem value={'Apellidos'}>Apellidos</MenuItem>
                                            <MenuItem value={'Telefono'}>Teléfono</MenuItem>
                                            <MenuItem value={'TipoVia'}>Tipo de vía</MenuItem>
                                            <MenuItem value={'NombreVia'}>Nombre de la vía</MenuItem>
                                            <MenuItem value={'NumeroVia'}>Número de vía</MenuItem>
                                            <MenuItem value={'RestoDireccion'}>Resto de la dirección</MenuItem>
                                            <MenuItem value={'CP'}>Código postal</MenuItem>
                                            <MenuItem value={'Municipio'}>Municipio</MenuItem>
                                            <MenuItem value={'Provincia'}>Provincia</MenuItem>
                                            <MenuItem value={'FechaNacimiento'}>Fecha de nacimiento</MenuItem>
                                            <MenuItem value={'Email'}>Email</MenuItem>
                                            <MenuItem value={'Sexo'}>Sexo</MenuItem>
                                            <MenuItem value={'URL'}>URL</MenuItem>
                                            <MenuItem value={'IP'}>IP</MenuItem>
                                            <MenuItem value={'Operador'}>Operador</MenuItem>
                                            <MenuItem value={'CupsLuz'}>Cups luz</MenuItem>
                                            <MenuItem value={'CupsGas'}>Cups gas</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="fieldOperator">Operador</InputLabel>
                                        <Select
                                            labelId="fieldOperator"
                                            id="fieldOperatorSelect"
                                            label="Operador"
                                            value={searchModel.operator}
                                            onChange={(event: SelectChangeEvent) => {
                                                const searchModel: SearchModel[] = this.state.searchModel;

                                                searchModel[index].operator = event.target.value as string;

                                                this.setState(
                                                    {
                                                        searchModel: searchModel
                                                    }
                                                );
                                            }}
                                        >
                                            <MenuItem value={'eq'}>es igual a</MenuItem>
                                            <MenuItem value={'neq'}>no es igual a</MenuItem>
                                            <MenuItem value={'start'}>empieza por</MenuItem>
                                            <MenuItem value={'end'}>termina por</MenuItem>
                                            <MenuItem value={'contains'}>contiene</MenuItem>
                                            <MenuItem value={'geq'}>es mayor o igual que</MenuItem>
                                            <MenuItem value={'leq'}>es menor o igual que</MenuItem>
                                            <MenuItem value={'gq'}>es mayor que</MenuItem>
                                            <MenuItem value={'lq'}>es menor que</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={this.props.multiFields ? 4 : 6}>
                                    {
                                        searchModel.field == 'Sexo' && (
                                            <FormControl fullWidth>
                                                <InputLabel id="sexLabel">Sexo</InputLabel>
                                                <Select
                                                    labelId="sexLabel"
                                                    id="sexSelect"
                                                    label="Sexo"
                                                    value={searchModel.value}
                                                    onChange={(event: SelectChangeEvent) => {
                                                        const searchModel: SearchModel[] = this.state.searchModel;

                                                        searchModel[index].value = event.target.value as string;

                                                        this.setState(
                                                            {
                                                                searchModel: searchModel
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <MenuItem value={'h'}>Hombre</MenuItem>
                                                    <MenuItem value={'m'}>Mujer</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )
                                    }
                                    {
                                        searchModel.field == 'TipoVia' && (
                                            <FormControl fullWidth>
                                                <InputLabel id="tipoViaLabel">Seleccione un tipo de vía</InputLabel>
                                                <Select label="Seleccione un tipo de vía" labelId='tipoViaLabel' onChange={(event: SelectChangeEvent) => {
                                                    const searchModel: SearchModel[] = this.state.searchModel;

                                                    searchModel[index].value = event.target.value as string;

                                                    this.setState(
                                                        {
                                                            searchModel: searchModel
                                                        }
                                                    );
                                                }}>
                                                    {
                                                        this.state.tiposVia.map((value: TipoVia, index: number) => {
                                                            return (
                                                                <MenuItem value={value.nombre}>
                                                                    {
                                                                        value.nombre
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        )
                                    }
                                    {
                                        searchModel.field == 'Municipio' && (
                                            <Autocomplete
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Seleccione un municipio" />
                                                )}
                                                onChange={(event: any, newValue: Municipio | null) => {
                                                    const searchModel: SearchModel[] = this.state.searchModel;

                                                    searchModel[index].value = newValue!.nombre as string;

                                                    this.setState(
                                                        {
                                                            searchModel: searchModel
                                                        }
                                                    );
                                                }}
                                                options={this.state.municipios}
                                                getOptionLabel={(option: Municipio) => option.nombre!}
                                                renderOption={(props, item) => (
                                                    <li {...props} key={item.id}>
                                                    <ListItemText>{item.nombre}</ListItemText>
                                                    </li>
                                                )}
                                            />
                                        )
                                    }
                                    {
                                        searchModel.field == 'Provincia' && (
                                            <FormControl fullWidth>
                                                <InputLabel id="provinciaLabel">Seleccione una provincia</InputLabel>
                                                <Select required label="Seleccione una provincia" labelId='provinciaLabel' onChange={(event: SelectChangeEvent) => {
                                                    const searchModel: SearchModel[] = this.state.searchModel;

                                                    searchModel[index].value = event.target.value as string;

                                                    this.setState(
                                                        {
                                                            searchModel: searchModel
                                                        }
                                                    );
                                                }}>
                                                    {
                                                        this.state.provincias.map((value: Provincia, index: number) => {
                                                            return (
                                                                <MenuItem value={value.nombre}>
                                                                    {
                                                                        value.nombre
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        )
                                    }
                                    {
                                        searchModel.field == 'FechaNacimiento' && (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <FormControl fullWidth>
                                                    <DatePicker onChange={(newValue) => {
                                                        console.log(newValue!.toISOString());
                                                        const searchModel: SearchModel[] = this.state.searchModel;
        
                                                        searchModel[index].value = newValue!.toISOString();
                
                                                        this.setState(
                                                            {
                                                                searchModel: searchModel
                                                            }
                                                        );
                                                    }}/>
                                                </FormControl>
                                            </LocalizationProvider>
                                        )
                                    }
                                    {
                                        searchModel.field != 'Sexo' && searchModel.field != 'TipoVia' && searchModel.field != 'Municipio' && searchModel.field != 'Provincia' && searchModel.field != 'FechaNacimiento' && (
                                            <TextField fullWidth label="Valor" defaultValue={searchModel.value} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                const searchModel: SearchModel[] = this.state.searchModel;
        
                                                searchModel[index].value = event.target.value;
        
                                                this.setState(
                                                    {
                                                        searchModel: searchModel
                                                    }
                                                );
                                            }}/>
                                        )
                                    }
                                </Grid>
                                {
                                    this.props.multiFields && (
                                        <Grid item xs={2}>
                                            <FormControl fullWidth>
                                                <InputLabel id="field">Agregar campo</InputLabel>
                                                <Select
                                                    labelId="field"
                                                    id="addFieldSelect"
                                                    label="Agregar campo"
                                                    onChange={(event: SelectChangeEvent) => {
                                                        const searchModel: SearchModel[] = this.state.searchModel;
                                                        searchModel[index].concatenator = event.target.value as string;

                                                        const newField = searchModel.find((value: SearchModel) => {
                                                            return value.field == '';
                                                        });

                                                        if(newField == null && index == searchModel.length - 1) {
                                                            searchModel.push(
                                                                {
                                                                    field: '',
                                                                    value: '',
                                                                    operator: '',
                                                                    concatenator: ''
                                                                }
                                                            );
            
                                                            this.setState(
                                                                {
                                                                    searchModel: searchModel
                                                                }
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value={'0'}></MenuItem>
                                                    <MenuItem value={'and'}>y</MenuItem>
                                                    <MenuItem value={'or'}>o</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )
                                }
                            </Grid>
                        )
                    })
                }
                <div className='textRight'>
                    <Button variant='contained' onClick={this.Search.bind(this)}>
                        Buscar
                    </Button>
                </div>
            </React.Fragment>
        )
    }

    private GetTiposVia(): void {
        let url = `${Common.END_POINT}/masters/tiposVia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    tiposVia: response
                }
            );
        })
    }

    private GetMunicipios(): void {
        let url = `${Common.END_POINT}/masters/municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    municipios: response
                }
            );
        })
    }

    private GetProvincias(): void {
        let url = `${Common.END_POINT}/masters/provincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    provincias: response
                }
            );
        })
    }

    private Search() {
        if(this.props.extracciones) {
            this.SearchExtracciones();
            return;
        }
        
        let url = `${Common.END_POINT}/extracciones/${this.props.clientId}/search`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this.state.searchModel),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(this.props.onSearchEnd != null) {
                this.props.onSearchEnd(response, this.state.searchModel);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }

    private SearchExtracciones() {
        let url = `${Common.END_POINT}/extracciones/search`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this.state.searchModel),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(this.props.onSearchEnd != null) {
                this.props.onSearchEnd(response, this.state.searchModel);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            
        });
    }
}